/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";

export const  getFornecedorSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  filtro.fields = ['*']
  return filtro
}
export const FornecedorSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['nome', 'bairro', 'municipios.descricao as municipio', 'fornecedores.bloqueado']
    filtro.addOrder('nome', 'asc')
    filtro.join.addLeft('municipios','municipios.municipio_id','fornecedores.municipio_id')
  return filtro
}
